import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/Linkicons/TV.svg'


const _withScopeId = n => (_pushScopeId("data-v-8fdf26ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "filter-bar-tv-menu",
  "data-uk-tooltip": "",
  title: "AskNicely TV"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "options" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "option",
    href: "/tv/slideshow"
  }, "Launch Slideshow"),
  /*#__PURE__*/_createElementVNode("a", {
    class: "option",
    href: "/tv/edit"
  }, "Configure Slideshow"),
  /*#__PURE__*/_createElementVNode("a", {
    class: "option",
    target: "setupguide",
    href: "https://asknicely.zendesk.com/hc/en-us/articles/4401989471380"
  }, [
    /*#__PURE__*/_createTextVNode(" TV Setup Guide "),
    /*#__PURE__*/_createElementVNode("img", { src: "/img/icons/external_link.svg" })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Dropdown, { right: "" }, {
      trigger: _withCtx(() => [
        _createElementVNode("a", {
          class: "trigger",
          href: "/tv",
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
        }, _hoisted_3)
      ]),
      content: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    })
  ]))
}